import { capitalize } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";

const Icons = {
  "circle-radio-checked": "tick-circle.svg",
  "box-checkbox-checked": "checked-square.svg",
  "circle-radio": "radio-unchecked.svg",
  "box-checkbox": "unchecked-square.svg",
};

const QuestionMultiple = ({ type, options, answers }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    if (answers) {
      setSelectedOptions([...answers]);
    }
  }, [answers]);

  return (
    <div className="question-description-multiple">
      {options.map((option, key) => (
        <div key={key} className="question-multiple-group">
          {selectedOptions.includes(option) ? (
            <SvgIcon
              noFilterOnLight={true}
              src={`/img/new-icons/${Icons[`${type}-checked`]}`}
            />
          ) : (
            <SvgIcon src={`/img/new-icons/${Icons[`${type}`]}`} />
          )}
          <span
            className={
              selectedOptions.includes(option)
                ? "question-multiple-label-checked"
                : "question-multiple-label"
            }
          >
            {String(option)}
          </span>
        </div>
      ))}
    </div>
  );
};

export const CreateQuestionMultiple = ({ type, data, setData }) => {
  const { t } = useTranslation("athlete-portal");
  const initialInputs = data.body.options ? [...data.body.options, ""] : [""];

  const [inputs, setInputs] = useState(initialInputs);

  const handleInputChange = (event, index) => {
    const { value } = event.target;
    let newInputs;

    // Checks to see if the user deleted an input that is not followed by an empty one
    // If it does, it deletes the last one
    if (value === "" && inputs.length > 1 && inputs[index + 1] === "") {
      newInputs = [...inputs];
      newInputs.splice(index, 1);
    } else {
      newInputs = [...inputs];
      newInputs[index] = capitalize(value);
      if (index === inputs.length - 1) {
        newInputs.push("");
      }
    }

    setData((previousState) => ({
      ...previousState,
      body: {
        ...previousState.body,
        options: newInputs.slice(0, -1),
      },
    }));

    setInputs(newInputs);
  };

  return (
    <div className="answer-short-body">
      <div className="answer-group-list">
        {inputs.map((value, index) => (
          <div
            key={`question-${type}-${index}`}
            className="question-multiple-group"
          >
            <SvgIcon src={`/img/new-icons/${Icons[`${type}`]}`} />
            <input
              type="text"
              name="question-short"
              placeholder={t("questionOptions.optionPlaceholder", { number: index + 1 })}
              className="answer-input-multiple"
              value={value}
              onChange={(event) => handleInputChange(event, index)}
            />
          </div>
        ))}
      </div>
      <div className="no-buttons"></div>
    </div>
  );
};

export default QuestionMultiple;
